import React, { useEffect, useState } from 'react';
import { Row, Form, Col, Button } from "react-bootstrap"
import newProject from '../../api/newProject';
import { useHistory } from "react-router-dom";
import { CREATE_NEW_PROJECT_HEADER } from '../../constants/headerTitles';
import { updateTitle } from '../../redux/updatePageHeadeSlice';
import { useDispatch } from 'react-redux';
const CreateProject = () => {
    const dispatch = useDispatch()
    const [data, setData] = useState({ project_name: "", description: "" });
    const history = useHistory()

    useEffect(() => {
        dispatch(updateTitle(CREATE_NEW_PROJECT_HEADER))
    }, [])

    const submitNewProject = async (e) => {
        e.preventDefault();
        await newProject(data);
        history.push("/home");
    }

    const changeData = (key, e) => {
        setData({ ...data, [key]: e.target.value })
    }

    return (
        <>
            {/* <Form onSubmit={submitNewProject}>
                <Row className="mb-3">
                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Project Name</Form.Label>
                        <Form.Control value={data.project_name} onChange={(e) => changeData("project_name", e)} type="text" />
                    </Form.Group>
                </Row>

                <Form.Group className="mb-3" controlId="formGridAddress1">
                    <Form.Label>Project Description</Form.Label>
                    <Form.Control value={data.description} onChange={(e) => changeData("description", e)} as="textarea" placeholder="project description ..." rows={3} />
                </Form.Group>
                <div className="text-center">
                    <Button
                        type="submit"
                        className="mt-3"
                        variant="primary"
                    >
                        Save
                    </Button>
                </div>
            </Form> */}
        </>

    );
}

export default CreateProject;
